// extracted by mini-css-extract-plugin
export var askAiIcon = "_lv-j";
export var category = "_lv-9";
export var categoryHeader = "_lv-e";
export var container = "_lv-0";
export var group = "_lv-a";
export var groupItems = "_lv-f";
export var groupSeparator = "_lv-k";
export var loading = "_lv-1";
export var noResults = "_lv-3";
export var placeholder = "_lv-2";
export var resultContent = "_lv-5";
export var resultIcon = "_lv-c";
export var resultItem = "_lv-g";
export var resultMeta = "_lv-8";
export var resultSubtitle = "_lv-7";
export var resultSuffix = "_lv-i";
export var resultTitle = "_lv-6";
export var resultsList = "_lv-4";
export var searchGroup = "_lv-d";
export var selected = "_lv-h";
export var subgroup = "_lv-b";